// replace the user pool region, id, and app client id details
const awsExports_Obj = {
  REGION: process.env.REACT_APP_COGNITO_REGION,
  USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  USER_POOL_APP_CLIENT_ID: process.env.REACT_APP_COGNITO_USER_POOL_APP_CLIENT_ID,
};

export default awsExports_Obj;
